module.exports = __webpack_public_path__ + "static/media/2.c04871ae.jpg";